import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import CorredorLiquidacionDetalleForm from './CorredorLiquidacionDetalleForm';
import CorredorLiquidacionDetalleSummary from './CorredorLiquidacionDetalleSummary';
import CorredorLiquidacionDetalleTable from './CorredorLiquidacionDetalleTable';
import { API, BASE_URL } from '../../../CONST';
import { get } from '../../../helpers/requests';
import useState from '../../shared/useState';

const initialState = {
  id: 0,
  comision_neta: 0,
  factura_uuid: null,
  factura_numero: null,
  folio_liquidacion: null,
  pagos_credito: [],
  pagos_garantia: [],
  periodo: '',
  prima_neta: 0,
  tipo: { descripcion: '' },
};

const CorredorLiquidacionDetalle = ({ liquidacionId, corredor, tipo }) => {
  const { state, setState, handleStateChange } = useState(initialState);

  useEffect(() => {
    const url = `${BASE_URL}${API.liquidacion}/${liquidacionId}/`;
    get(corredor ? `${url}?corredor_id=${corredor.id}` : url).then((resp) => setState(resp));
  }, [liquidacionId]);

  return (
    <div className="container-padding">
      <Row md="2" xs="1">
        <Col>
          <CorredorLiquidacionDetalleForm
            liquidacion={state}
            setLiquidacion={setState}
            setLiquidacionField={handleStateChange}
            corredor={corredor}
          />
        </Col>
        <Col md="4">
          <CorredorLiquidacionDetalleSummary
            primaNetaTotal={state.prima_neta}
            comisionNetaTotal={state.comision_neta}
          />
        </Col>
        <Col md="12">
          <CorredorLiquidacionDetalleTable
            liquidacionId={state.id}
            periodo={state.periodo}
            pagos={tipo === 'credito' ? state.pagos_credito : state.pagos_garantia}
            tipo={tipo}
            corredor={corredor}
          />
        </Col>
      </Row>
    </div>
  );
};

CorredorLiquidacionDetalle.propTypes = {
  liquidacionId: PropTypes.string.isRequired,
  corredor: PropTypes.shape({
    id: PropTypes.number,
  }),
  tipo: PropTypes.oneOf(['credito', 'garantia']).isRequired,
};

CorredorLiquidacionDetalle.defaultProps = {
  corredor: null,
};

export default CorredorLiquidacionDetalle;
